import { render, staticRenderFns } from "./equipmentInfo.vue?vue&type=template&id=5383178c&scoped=true"
import script from "./equipmentInfo.vue?vue&type=script&lang=js"
export * from "./equipmentInfo.vue?vue&type=script&lang=js"
import style0 from "./equipmentInfo.vue?vue&type=style&index=0&id=5383178c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383178c",
  null
  
)

export default component.exports